import { render, staticRenderFns } from "./LeaseholdInformation.vue?vue&type=template&id=7235543d&"
import script from "./LeaseholdInformation.vue?vue&type=script&lang=js&"
export * from "./LeaseholdInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports